import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { deepCamelCaseKeys } from 'src/utils/deepCamelCaseKeys';
import { sessionStore } from 'src/store/sessionStore';
import { auth } from 'src/config/firebase';

export interface UnreadConversation {
  chatId: string;
  clientUid: string;
  unreadCount: number;
}

export interface TrainerUnreadMessagesResponse {
  unread: UnreadConversation[];
  totalUnread: number;
}

export const fetchTrainerUnreadMessages = async (): Promise<TrainerUnreadMessagesResponse> => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Not authenticated');

  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_UNREAD_MESSAGES}`;

  const response = await fetch(apiUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error?.message || `Failed to fetch unread messages: ${response.status}`);
  }

  const res = await response.json();
  const parsedData = deepCamelCaseKeys(res);

  return parsedData as TrainerUnreadMessagesResponse;
};

export function useGetTrainerUnreadMessages() {
  const currentUser = sessionStore((s) => s.currentUser);
  const trainerId = currentUser?.uid;

  return useQuery({
    queryKey: ['trainer-unread-messages', trainerId],
    queryFn: () => fetchTrainerUnreadMessages(),
    enabled: !!trainerId,
    staleTime: 5 * 60 * 1000,
  });
}
